module.exports = __webpack_public_path__ + "1ac6f31d1d151e415fad4f548783be43.svg";